import React, { useState, useEffect } from 'react';
import WebpackerReact from 'webpacker-react';
import Swal from "sweetalert2/dist/sweetalert2.js";
import 'sweetalert2/dist/sweetalert2.min.css'; // Importar los estilos de SweetAlert2
import SweetAlert from "sweetalert2-react";
import { NumericFormat } from 'react-number-format';
import DiscountCodeForm from '../../../components/affiliate/payments/DiscountCodeForm'

import PublicationShow from '../../../components/affiliate/payments/PublicationShow';
import UserIndex from '../../../components/affiliate/payments/UserIndex';
import PaymentForm from '../../../components/affiliate/payments/PaymentForm';
import PaymentCompleted from '../../../components/affiliate/payments/PaymentCompleted';
import ReactPlayer from 'react-player'

const CheckoutPayment = (props) => {
    const token = document.querySelector("[name='csrf-token']").content;
    const [showDiscounForm, setShowDiscounForm] = useState(false);
    const [isLoadedDiscountCode, setIsLoadedDiscountCode] = useState(false);
    const [prices, setPrices] = useState(props.price.prices);
    const [discount, setDiscoun] = useState({ id: "",  discount: "", show: false });
    const [price, setPrice] = useState(props.price.price);
    const [user, setUser] = useState(props.current_user.user_logged_in ? props.current_user.user : {} );
    const [activeTab, setActiveTab] = useState(props.status);
    const [currentTab, setCurrentTab] = useState(props.current_tab);
    const [cadena, setCadena] = useState(props.cadena);
    const [videoPlayer, setVideoPlayer] = useState({
        playing: true
    });

    const [form, setForm] = useState({ 
        code: "",
        reference: props.reference
    });

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Mensaje personalizado (algunos navegadores no lo muestran)
            event.preventDefault();
            event.returnValue = "¿Estás seguro de que quieres recargar la página?";
            return "¿Estás seguro de que quieres recargar la página?";
        };
    
        // Agregar el evento
        window.addEventListener("beforeunload", handleBeforeUnload);
    
        // Limpiar el evento al desmontar el componente
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    const toogle = () => {
        if(showDiscounForm){
            setShowDiscounForm(false);
        }else{
            setShowDiscounForm(true);
            clearValues();
        }
    }

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value })
    }

    const clearValues = () => {
        setForm({ 
            code: "",
            reference: props.reference
        })
    }

    const messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    const toogleTab = (current_tab) => {
        setActiveTab([...activeTab, current_tab])
        setCurrentTab(current_tab)
    }

    const toogleTabUser = (current_tab) => {
        setActiveTab(["general", "user_info", "payment"])
        setCurrentTab(current_tab)
    }

    const toogleVideoPlayer = (name, value) => {
        setVideoPlayer({ ...videoPlayer, [name]: value })
    }

    const setUserState = (user) => {
        setUser(user)
    }

    const handleClick = () => {
        if(true){
            setIsLoadedDiscountCode(true)
            fetch(`/affiliate/discount_code/${props.price.id}`, {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(form), // data can be `string` or {object}!
                headers: {
                    "X-CSRF-Token": token,
                    "authorization": "98a2425c7cd22d4dad50",
                    "Content-Type": "application/json"
                }
            })

            .then(res => res.json())
            .catch(error => console.error("Error:", error))
            .then(data => {
                if(data.type == "success"){
                    messageSuccess(data)
                    setIsLoadedDiscountCode(false);
                    setDiscoun(data.register);
                    setPrices(data.prices);
                    setCadena(data.signature);
                }else{
                    setIsLoadedDiscountCode(false);
                    messageSuccess(data);
                    setDiscoun({})
                }
            });
        }
    }

    return (
        <React.Fragment>
            <div className="container mt-4">
                <div className="row">
                    <div className="col-md-7">
                        <div className="card">
                            <div className="card-body">

                                <div className="stepper-wrapper">
                                    <div className={`stepper-item ${activeTab.includes("general") ? "completed" : "text-dark"}`}>
                                        <div className="step-counter">1</div>
                                        <div className={`step-name ${activeTab.includes("general") ? "completed" : "text-dark"}`}>Información del curso</div>
                                    </div>

                                    {!props.current_user.user_logged_in && (
                                        <div className={`stepper-item ${activeTab.includes("user_info") ? "completed" : "text-dark"}`}>
                                            <div className="step-counter">2</div>
                                            <div className={`step-name ${activeTab.includes("user_info") ? "completed" : "text-dark"}`}>Información de usuario</div>
                                        </div>
                                    )}

                                    <div className={`stepper-item ${activeTab.includes("payment") ? "completed" : "text-dark"}`}>
                                        <div className="step-counter">3</div>
                                        <div className={`step-name ${activeTab.includes("payment") ? "completed" : "text-dark"}`}>Información del pago</div>
                                    </div>

                                    <div className={`stepper-item ${activeTab.includes("payment_completed") ? "completed" : "text-dark"}`}>
                                        <div className="step-counter">4</div>
                                        <div className={`step-name ${activeTab.includes("payment_completed") ? "completed" : "text-dark"}`}>Pago completo</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {currentTab == "general" && (
                            <div className="general">
                                <PublicationShow
                                    toogleTab={toogleTab}
                                    publicacion={props.course}
                                    affiliate={props.affiliate}
                                />
                            </div>
                        )}

                        {currentTab == "user_info" && (
                            <div className="user_info">
                                <UserIndex
                                    errorValues={true}
                                    toogleTab={toogleTab}
                                    document_types={props.document_types}
                                    professions={props.professions}
                                    countries={props.countries}
                                    cities={props.cities}
                                    setUserState={setUserState}
                                    price={props.price}
                                    discount={discount}
                                    current_country={props.current_country}
                                />
                            </div>
                        )}

                        {currentTab == "payment" && (
                            <div className="payment">
                                <PaymentForm
                                    discount_code={discount}
                                    mode={props.mode}
                                    affiliate={props.affiliate}
                                    user={user}
                                    price={props.price}
                                    errorValues={true}
                                    cadena={cadena}
                                    pub_test={props.pub_test}
                                    reference={props.reference}
                                    return_url={props.return_url}
                                    current_country={props.current_country}
                                    setUserState={setUserState}
                                    webhooks={props.webhooks}
                                    prices={prices}
                                    toogleTab={toogleTab}
                                    client_paypal={props.client_paypal}

                                    //modal update payment info
                                    countries={props.countries}
                                    document_types={props.document_types}
                                    cities={props.cities}
                                />
                            </div>
                        )}

                        {currentTab == "payment_completed" && (
                            <div className="payment_completed">
                                <PaymentCompleted
                                    publicacion={props.course}
                                    price={props.price}
                                    affiliate={props.affiliate}
                                />
                            </div>
                        )}
                    </div>

                    <div className="col-md-5">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <img src={props.course.image.url} alt="" className="img-fluid"/>
                                    </div>
                                    
                                    <div className="col-md-12">
                                        <hr />
                                    </div>

                                    <div className="col-md-12 mb-5 text-center">
                                        <ReactPlayer
                                            playing={videoPlayer.playing}
                                            volume={0.103}
                                            className='react-player'
                                            url={props.course.url_video_promotional}
                                            width='100%'
                                            height='100%'
                                        />

                                        <div className="text-center">
                                            <button 
                                                className='btn-media-player'
                                                onClick={() => toogleVideoPlayer("playing", !videoPlayer.playing)}
                                            >
                                                {videoPlayer.playing ? "Parar video" : "Reproducir"}
                                            </button>
                                        </div>
                                    </div>
                                    
                                    <div className="col-md-12">

                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td className='text-primary'>{"Precio:"}</td>
                                                    <td className='text-right'><b className='text-primary'>{props.price.currency.code}</b> <NumericFormat displayType={"text"} thousandSeparator={true} value={props.price.price} /></td>
                                                </tr>

                                                {discount.show && (
                                                    <tr>
                                                        <td>{"Precio con el código"}</td>
                                                        <td className='text-right'><b className='text-primary'>{props.price.currency.code}</b> <NumericFormat displayType={"text"} thousandSeparator={true} value={discount.discount} /></td>
                                                    </tr> 
                                                )}

                                                {false && (
                                                    <tr>
                                                        <td>{"Sub Total"}</td>
                                                        <td className='text-right'><NumericFormat displayType={"text"} thousandSeparator={true} prefix={'$'} value={props.price.price} /></td>
                                                    </tr>
                                                )}

                                                <tr>
                                                    <td>{""}</td>
                                                    <td className='text-right'><b className='text-primary'>{props.price.currency.code}</b> <NumericFormat displayType={"text"} thousandSeparator={true} value={discount.show ? discount.discount : props.price.price} /></td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {(currentTab != "user_info" && currentTab != "payment" && currentTab != "payment_completed")  && (
                                            <div className="col-md-12 p-0">
                                                <button 
                                                    className='btn btn-primary btn-lg btn-block' 
                                                    onClick={() => props.current_user.user_logged_in ? toogleTabUser("payment") : toogleTab("user_info")}
                                                > 
                                                    Pagar 
                                                </button>
                                            </div>
                                        )}
                                    </div>


                                    {(currentTab != "payment" && currentTab != "payment_completed") && (
                                        <div className="col-md-12 text-center mt-4">
                                            {showDiscounForm && (
                                                <DiscountCodeForm
                                                    formValues={form}
                                                    handleChange={handleChange}
                                                    handleClick={handleClick}
                                                    errorValues={true}
                                                    isLoadedDiscountCode={isLoadedDiscountCode}
                                                />
                                            )}
                                            <a onClick={() => toogle()} href='javascript:void(0)' className='mt-4 text-primary'>{showDiscounForm ? "Cerrar" : "Abrir"} formulario de código de descuento</a>
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}


export default CheckoutPayment;
WebpackerReact.setup({ CheckoutPayment })
